import { FormRow } from 'native/view/components/skiold-components/skiold-forms/skiold-forms-wrapper-types';
import React from 'react';
import { AnimalType, IGeneralSettings } from 'shared/api/api';
import { localized } from 'shared/state/i18n/i18n';
import { FlexRow } from 'web/view/components/basic-flex/flex-row';
import { SkioldFormIntegerInput } from 'web/view/components/skiold-components/skiold-integer-input/skiold-form-integer-input';
import { ViewWeb } from 'web/view/components/utils/web-view';
import { TextWeb } from 'web/web-helpers/styled-text-components';

interface Settings {
	setGeneralSetting: React.Dispatch<React.SetStateAction<IGeneralSettings>>;
	generalSetting: IGeneralSettings;
}

export const getNotifyCapacitySows = (props: Settings): FormRow => {
	const { generalSetting, setGeneralSetting } = props;

	const onChangeMatingCapacity = (value: number | undefined) => {
		setGeneralSetting({ ...generalSetting, distriwinNotifyCapacityMatingLocations: value });
	};

	const onChangePregnantCapacity = (value: number | undefined) => {
		setGeneralSetting({ ...generalSetting, distriwinNotifyCapacityPregnantLocations: value });
	};

	const onChangeFarrowingCapacity = (value: number | undefined) => {
		setGeneralSetting({ ...generalSetting, distriwinNotifyCapacityFarrowingLocations: value });
	};

	const formRow: FormRow = {
		name: localized('NotifyCapacity'),
		component: (
			<ViewWeb className="width-100-pct default-padding">
				<FlexRow className="flex-row-space-between align-items-center">
					<TextWeb>{localized('MatingLocations')}</TextWeb>
					<ViewWeb className="border-line-container-basic percentage-suffix flex-row">
						<SkioldFormIntegerInput
							className="column-text-input-basic"
							text={generalSetting.distriwinNotifyCapacityMatingLocations}
							onChangeNumber={onChangeMatingCapacity}
						/>
					</ViewWeb>
				</FlexRow>
				<FlexRow className="flex-row-space-between align-items-center">
					<TextWeb>{localized('PregnantLocations')}</TextWeb>
					<ViewWeb className="border-line-container-basic percentage-suffix flex-row">
						<SkioldFormIntegerInput
							className="column-text-input-basic"
							text={generalSetting.distriwinNotifyCapacityPregnantLocations}
							onChangeNumber={onChangePregnantCapacity}
						/>
					</ViewWeb>
				</FlexRow>
				<FlexRow className="flex-row-space-between align-items-center">
					<TextWeb>{localized('FarrowingLocations')}</TextWeb>
					<ViewWeb className="border-line-container-basic percentage-suffix flex-row">
						<SkioldFormIntegerInput
							className="column-text-input-basic"
							text={generalSetting.distriwinNotifyCapacityFarrowingLocations}
							onChangeNumber={onChangeFarrowingCapacity}
						/>
					</ViewWeb>
				</FlexRow>
			</ViewWeb>
		),
		style: { height: 140 },
	};

	return formRow;
};

export const getNotifyCapacity = (animalType: AnimalType, settings: Settings): FormRow => {
	const { generalSetting, setGeneralSetting } = settings;

	const currentValue =
		animalType === AnimalType.Finisher
			? generalSetting.notifyCapacityFinisher
			: generalSetting.notifyCapacityWeaner
			? generalSetting.notifyCapacityWeaner
			: 0;

	const onChangeCapacity = (value: number | undefined) => {
		if (animalType === AnimalType.Finisher) {
			setGeneralSetting({ ...generalSetting, notifyCapacityFinisher: value });
		} else if (animalType === AnimalType.Weaner) {
			setGeneralSetting({ ...generalSetting, notifyCapacityWeaner: value });
		}
	};

	return {
		name: localized('NotifyCapacity'),
		component: (
			<ViewWeb className="percentage-suffix flex-row border-line-container-basic">
				<SkioldFormIntegerInput
					className="column-text-input-basic"
					text={currentValue}
					onChangeNumber={onChangeCapacity}
				/>
			</ViewWeb>
		),
	};
};
